import type { WeddingData } from '@/mock/types'
import { type Venue, venueIdentity } from '@/mock/venues'

export const useSuggestions = [
  'Obřad',
  'Hostina a oslava',
  'Přípravy',
  'Ubytování',
  'Focení',
  'Afterparty',
]

export const normalize = (value: string) =>
  value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim()
    .toLocaleLowerCase('cs')

export function sameVenueDraft(left: Venue, right: Venue) {
  const fields = (venue: Venue) => ({ ...venue, documents: venue.documents.map((doc) => doc.id) })
  return JSON.stringify(fields(left)) === JSON.stringify(fields(right))
}

export function venuePrompts(data: WeddingData) {
  return data.venues.flatMap((venue) => {
    const { name } = venueIdentity(venue, data)
    const prompts = []
    if (!venue.handover.trim())
      prompts.push({
        code: `venue-${venue.id}-handover`,
        venueId: venue.id,
        panel: 'overview',
        title: 'Jak proběhne předání místa?',
        hint: `${name} · kdo vám místo předá a kdy`,
      })
    if (!venue.access.trim())
      prompts.push({
        code: `venue-${venue.id}-access`,
        venueId: venue.id,
        panel: 'operations',
        title: 'Kudy přijedou dodavatelé?',
        hint: `${name} · příjezd a vykládka`,
      })
    return prompts.filter((prompt) => !data.hiddenPrompts.includes(prompt.code))
  })
}

export type VenueEditSection = 'identity' | 'agreement' | 'operations' | 'materials'
export const venueEditSections: VenueEditSection[] = [
  'identity',
  'agreement',
  'operations',
  'materials',
]
export const venueOperationFields = [
  {
    key: 'parking',
    label: 'Příjezd a parkování hostů',
    placeholder: 'Kde zaparkují hosté a kudy přijdou…',
  },
  {
    key: 'access',
    label: 'Příjezd dodavatelů a vykládka',
    placeholder: 'Kudy přijet a kdy se může vykládat…',
  },
  {
    key: 'accessibility',
    label: 'Přístupnost a pohyb po místě',
    placeholder: 'Schody, bezbariérový vstup nebo cesta s kočárkem…',
  },
  {
    key: 'accommodation',
    label: 'Ubytování',
    placeholder: 'Kapacita, check-in a na čem jste se domluvili…',
  },
] satisfies {
  key: 'parking' | 'access' | 'accessibility' | 'accommodation'
  label: string
  placeholder: string
}[]
